<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { store } from "./store/store";
export default {
  name: 'App',
  mounted(){
    store.set("goLoginRouter", () => {
       sessionStorage.clear();
       this.$router.push({ name: "login", replace: true });
    });
  }
}
</script>

<style scoped lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}
.loadingclass {
    .el-loading-spinner {
      i {
        color: #139cb6;
      }
      .el-loading-text {
        color: #139cb6;
      }
    }
  }
</style>
